
import './App.css';
import React from 'react';
import Login from '../Login/Login';
import { Routes, Route } from 'react-router-dom';
import { NextUIProvider } from "@nextui-org/react";
import CustomerPortal from '../CustomerPotal/CustomerPortal';
import StaffPanel from '../Staff-panel/StaffPanel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RedirectMenu from '../RedirectMenu/RedirectMenu';
import ContactUs from '../ContactUs/ContactUs';
import { faGrip, faUser, faFileInvoice, faCreditCard, faUserGroup } from '@fortawesome/free-solid-svg-icons';
import { StaffContextProvider } from '../Staff-panel/Services/staff.context';
import { IdleTimerProvider } from 'react-idle-timer';
import StaffPanelLogin from '../Login/StaffPanelLogin';

const sideMenu = [
  {
    icon: <FontAwesomeIcon icon={faGrip} />
    ,
    label: "Dashboard",

    url: "",
    isDisabled: false
  },
  
  {
    icon: <FontAwesomeIcon icon={faUser} />,
    label: "My Account",
    url: "myaccount",
    isDisabled: false
  },
  {
    icon: <FontAwesomeIcon icon={faUserGroup} />
    ,
    label: "Customer Servicing",
    url: "customer-servicing",
    isDisabled: false

  },
  {
    icon: <FontAwesomeIcon icon={faFileInvoice} />
    ,
    label: "E-statement",
    url: "e-statement",
    isDisabled: false
  },
  {
    icon: <FontAwesomeIcon icon={faCreditCard} />
    ,
    label: "Premium Payments"
    , url: "premium-payments",
    isDisabled: true
  }
  ,

  {
    icon: <FontAwesomeIcon icon={faUserGroup} />
    ,
    label: "Requirement Fulfilment",
    url: "requirement-fulfilment",
    isDisabled: true
  },
  {
    icon: <FontAwesomeIcon icon={faUserGroup} />
    ,
    label: "Need Summary",
    url: "need-summary",
    isDisabled: true
  },
  {
    icon: <FontAwesomeIcon icon={faUserGroup} />
    ,
    label: "Fund Value"
    , url: "fund-value",
    isDisabled: true
  },






]


function App() {
  const idleTimerRef = React.useRef(null);

  const onIdle = () => {
    sessionStorage.clear();
    window.location.href = window.location.href;
  };
  return (

    <Routes>
      <Route path="customer-portal/login" element={

        <div className='bg-container' style={{ overflowX: "hidden" }}>
          <Login />
        </div>
      } />
      <Route path="customer-portal/contact-us" element={

        <div className='bg-container' style={{ overflowX: "hidden" }}>
          <ContactUs />
        </div>
      } />
      <Route path="customer-portal/staff-panel" element={

        <div style={{ overflowX: "hidden", backgroundColor: "white" }}>
          <IdleTimerProvider ref={idleTimerRef} timeout={15 * 60 * 1000} onIdle={onIdle}>
            <StaffContextProvider>
              <StaffPanel />
            </StaffContextProvider>
          </IdleTimerProvider>

        </div>
      } />
      <Route path="customer-portal/staff-login" element={

<div className='bg-container-staff' style={{ overflowX: "hidden" }}>
          <IdleTimerProvider ref={idleTimerRef} timeout={15 * 60 * 1000} onIdle={onIdle}>
           
             <StaffPanelLogin/>
            
          </IdleTimerProvider>

        </div>
      } />

      <Route
        path='customer-portal/redirect'
        element={
          <IdleTimerProvider ref={idleTimerRef} timeout={15 * 60 * 1000} onIdle={onIdle}>
            <RedirectMenu />
          </IdleTimerProvider>
        }
      />

      {
        sideMenu.map((value) => (
          <Route
            key={value.label}
            path={`/customer-portal/${value.url}`}
            element={
              <NextUIProvider>
                <IdleTimerProvider ref={idleTimerRef} timeout={15 * 60 * 1000} onIdle={onIdle}>
                  <CustomerPortal tab={value.url} sideMenu={sideMenu} />
                </IdleTimerProvider>
              </NextUIProvider>
            }
          />

        ))
      }


    </Routes>

  );
}

export default App;
